import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  display: flex;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px 20px;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-items: center;
`;
